import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Component, OnInit, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { InvoiceRejectService } from "src/app/services/http/business/invoiceReject/invoice-reject.service";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ErrorsService } from "src/app/services/common/errors.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-refound-entry",
  templateUrl: "./refound-entry.component.html",
  styleUrls: ["./refound-entry.component.css"]
})
export class RefoundEntryComponent implements OnInit {
  form: FormGroup;
  errObject: any;
  param: any;
  errorList: IError[] = [];
  PayCash:boolean=false;
  invoiceRejectCauseList: any = [];
  errors = new Array();
  refoundCalc: any;

  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private invoiceReject: InvoiceRejectService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RefoundEntryComponent>
  ) { }

  ngOnInit() {
    console.log(this.data);
  this.getinvoiceRejectCause();
    this.createForm();
    this.calculate();
  }

  createForm() {
    this.form = this.fb.group({
      Percent: [100, Validators.compose([Validators.required])],
      InvoiceRejectCauseId: [null,Validators.compose([Validators.required])],
      PayCash: [false],
      Id: this.data.Id
    });
  }

  getinvoiceRejectCause() {
    this.invoiceReject.invoiceRejectCauseCombo().subscribe(res => {

        this.invoiceRejectCauseList = res;
      });
}
  calculate() {
    this.invoiceReject.returnCalculation(this.data.Id).subscribe(res => {
      console.log(res);
      this.refoundCalc = res;

    }, err => {
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
      this.errorList = this.errorService.getErrorList(err.error);
    })
  }

  submit(data) {
    this.invoiceReject.returnInvoice(data).subscribe(() => {
      this.dialogRef.close();
      this.snackBar.OpenSnackBar(
        this.translate.get("success.returnInvoice"),
        "ok",
        5000,
        SoundEnum.beep
      );
    }, err => {
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
      this.errorList = this.errorService.getErrorList(err.error);
    })
  }

  onClose() {
    this.dialogRef.close();
  }
}
